<template>
    <div class="msg_wrap" v-if="errorMessage.message" :class="errorMessage.type" >
        <span class="msg">{{errorMessage.message }}</span> 
        <span v-on:click="close()" class="close-thick">&#x2715;</span>
    </div>
</template>

<style>
    .msg_wrap{
        position: absolute;
        /* border: 1px solid; */
        margin: 0;
        padding: 10px 10px 10px 15px;
        display: block;
        max-width: 450px;
        top: 10px;
        z-index: 99999;
        left: 0;
        right: 0;
        margin: auto;
        border-radius: 2px;
        font-size: 13px;
        font-family: OpenSans-Semibold;
        color: #fff;
    }
    .info {
        background-color:#2f96b4;
        border-color: #5fbad6
    }
    .success {
        background-color: #51a351;
        border-color:#67ac67;
    }
    .warning {
        background-color: #f89406;
        border-color: #f3aa44;

    }
    .error {
        background-color: #bd362f;
        border-color:#cf514b;
    }

    .hideMe {
        display:none;
    }

    .close-thick{
        color:#fff;
        right: 0;
        text-decoration: none;
        top: 0;
        position: absolute;
        cursor: pointer;
        font-size: 18px;
        width: 40px;
        height: 100%;
        opacity: .5;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: 0.1s linear;
        font-weight: bold;
    }
    .msg{
        padding-right: 26px;
        display: block;
        word-wrap: break-word;
    }
    .close-thick:hover{
        opacity: 1
    }
</style>

<script>
export default {

  name: 'Errors',
  props:['errorMessage'],
  data () {
    return {
            type: 'success',
            message: ''
        }
    },
    methods: {
        close(){
            this.errorMessage.type = 'hideMe';
        }
    }

}
</script>


// WEBPACK FOOTER //
// src/components/Errors.vue